export default __webpack_public_path__ + "static/media/portugal-flag-icon.ad2df15e.svg";